import * as Styled from './styles'

export function HeaderGroup({ children }: { children: any }): JSX.Element {
  return <Styled.Wrapper>{children}</Styled.Wrapper>
}
